export default __webpack_public_path__ + "static/media/CloseCircle.132c5b69.svg";